(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[86],{

/***/ 58797:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/[...slug]",
      function () {
        return __webpack_require__(29071);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 55404:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var _sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18518);
/* harmony import */ var _sparkpost_matchbox_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6848);
/* harmony import */ var utils_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14045);






var DocsIndexListPageContent = function(props) {
    var postsPerClick = 7;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(postsPerClick), paginationCount = ref[0], setPaginationCount = ref[1];
    var navigationData = props.navigationData;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            navigationData && navigationData.items ? navigationData.items.slice(0, paginationCount).map(function(item, i) {
                return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                            px: "500",
                            py: "650",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                                    as: "h3",
                                    children: item.title
                                }),
                                item.lastUpdated && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                                    pt: "200",
                                    pb: "400",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_3__/* .Tag */ .Vp, {
                                        children: (0,utils_string__WEBPACK_IMPORTED_MODULE_4__/* .formatDate */ .p6)(item.lastUpdated)
                                    })
                                }),
                                item.description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                                    as: "p",
                                    maxWidth: "1150",
                                    children: item.description
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                                    pt: "400",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                        href: item.link,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
                                            variant: "outline",
                                            color: "blue",
                                            children: "Read More"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {})
                    ]
                }, "navDataItem".concat(i)));
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: "Whoops! This section is empty."
            }),
            navigationData && navigationData.items && paginationCount < navigationData.items.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                textAlign: "center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
                    variant: "outline",
                    color: "blue",
                    onClick: function() {
                        return setPaginationCount(paginationCount + postsPerClick);
                    },
                    children: [
                        "Show More ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox_icons__WEBPACK_IMPORTED_MODULE_5__/* .KeyboardArrowDown */ .WdC, {})
                    ]
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (DocsIndexListPageContent);


/***/ }),

/***/ 48257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _layout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31277);
/* harmony import */ var _navigation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70337);



var DocsLayout = function(props) {
    var children = props.children, navigationData = props.navigationData;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        navigationComponent: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_navigation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            data: navigationData,
            title: "Documentation",
            titleLink: "/docs"
        }),
        children: children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (DocsLayout);


/***/ }),

/***/ 70337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var _sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18518);
/* harmony import */ var _sparkpost_matchbox_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6848);
/* harmony import */ var hooks_useStatus__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(381);
/* harmony import */ var _baseNavigation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44177);







var Navigation = function(props) {
    var _data = props.data, data = _data === void 0 ? [] : _data, title = props.title, titleLink = props.titleLink;
    var status = (0,hooks_useStatus__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().status;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_baseNavigation__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
        data: data,
        title: title,
        titleLink: titleLink,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
            py: "450",
            mt: "450",
            borderTop: "400",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
                    href: "/submit-a-ticket",
                    passHref: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_baseNavigation__WEBPACK_IMPORTED_MODULE_4__/* .StyledLink */ .Fg, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                            px: "500",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox_icons__WEBPACK_IMPORTED_MODULE_6__/* .Feedback */ .x2q, {
                                    size: 20
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                                    as: "span",
                                    pl: "300",
                                    children: "Submit a Ticket"
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
                    href: "http://slack.sparkpost.com",
                    passHref: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_baseNavigation__WEBPACK_IMPORTED_MODULE_4__/* .StyledLink */ .Fg, {
                        target: "_blank",
                        rel: "noreferrer",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                            px: "500",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox_icons__WEBPACK_IMPORTED_MODULE_6__/* .Forum */ .lWv, {
                                    size: 20
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                                    as: "span",
                                    pl: "300",
                                    children: "Community"
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
                    href: "https://www.sparkpost.com/case-studies/",
                    passHref: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_baseNavigation__WEBPACK_IMPORTED_MODULE_4__/* .StyledLink */ .Fg, {
                        target: "_blank",
                        rel: "noreferrer",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                            px: "500",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox_icons__WEBPACK_IMPORTED_MODULE_6__/* .PeopleOutline */ .cpR, {
                                    size: 20
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                                    as: "span",
                                    pl: "300",
                                    children: "Customers"
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
                    href: "https://www.sparkpost.com/blog/category/developer/",
                    passHref: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_baseNavigation__WEBPACK_IMPORTED_MODULE_4__/* .StyledLink */ .Fg, {
                        target: "_blank",
                        rel: "noreferrer",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                            px: "500",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox_icons__WEBPACK_IMPORTED_MODULE_6__/* .Code */ .EKh, {
                                    size: 20
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                                    as: "span",
                                    pl: "300",
                                    children: "Developer Blog"
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
                    href: "https://developers.sparkpost.com/",
                    passHref: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_baseNavigation__WEBPACK_IMPORTED_MODULE_4__/* .StyledLink */ .Fg, {
                        target: "_blank",
                        rel: "noreferrer",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                            px: "500",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox_icons__WEBPACK_IMPORTED_MODULE_6__/* .DeviceHub */ .wNG, {
                                    size: 20
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                                    as: "span",
                                    pl: "300",
                                    children: "Developer Hub"
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
                    href: "https://status.sparkpost.com/",
                    passHref: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_baseNavigation__WEBPACK_IMPORTED_MODULE_4__/* .StyledLink */ .Fg, {
                        target: "_blank",
                        rel: "noreferrer",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                            px: "500",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                                    as: "span",
                                    display: "inline-block",
                                    width: "20px",
                                    height: "20px",
                                    verticalAlign: "middle",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                                        width: "16px",
                                        height: "16px",
                                        backgroundColor: _baseNavigation__WEBPACK_IMPORTED_MODULE_4__/* .StatusColorMap */ .zK[status],
                                        borderRadius: "50%"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                                    as: "span",
                                    pl: "300",
                                    children: "Service Status"
                                })
                            ]
                        })
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Navigation);


/***/ }),

/***/ 29071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var context_categories__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18650);
/* harmony import */ var components_site_seo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51289);
/* harmony import */ var components_markdown__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64557);
/* harmony import */ var components_site_docsLayout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48257);
/* harmony import */ var components_site_documentationContent__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55721);
/* harmony import */ var components_site_docsIndexListPageContent__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(55404);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67294);









function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var PostPage = function(props) {
    var content = props.content, data = props.data, navigationData = props.navigationData, isIndex = props.isIndex, categoryData = props.categoryData;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(function() {
        var ref = _slicedToArray(router.asPath.split('?'), 2), path = ref[0], queryParams = ref[1];
        var tagId = router.asPath.split('#')[1];
        router.push(path + (tagId && queryParams ? '#' + tagId : ''));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // This is to check for a url that either contains a trailing slash or not (since netlify will show either)
    var trailingSlashOrNo = function(navData) {
        var linkComponents = navData.link.split('/');
        linkComponents.pop();
        var link = linkComponents.join('/');
        return link === router.asPath || link + '/' === router.asPath;
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(context_categories__WEBPACK_IMPORTED_MODULE_1__/* .CategoriesProvider */ .z, {
        data: categoryData,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_site_seo__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                title: data.title,
                description: data.description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_site_docsLayout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                navigationData: navigationData,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_site_documentationContent__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    title: data.title,
                    lastUpdated: data.lastUpdated,
                    isIndex: isIndex,
                    description: data.description,
                    children: isIndex && navigationData ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_site_docsIndexListPageContent__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        navigationData: navigationData.find(trailingSlashOrNo)
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_markdown__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        children: content
                    })
                })
            })
        ]
    }));
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (PostPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [398,267,371,178,774,888,179], function() { return __webpack_exec__(58797); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);